/**
 * Tiny IndexedDB helper for persisting the user's auth token so the
 * Service Worker can read it during background events like
 * `pushsubscriptionchange` — when the app is not open and localStorage
 * is not accessible to the SW.
 *
 * Single key/value store. No external deps.
 */

const DB_NAME = 'expatssphere-auth';
const DB_VERSION = 1;
const STORE = 'kv';
const TOKEN_KEY = 'token';

function openDB() {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === 'undefined') {
      reject(new Error('IndexedDB not supported'));
      return;
    }
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE);
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function dbSet(key, value) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, 'readwrite');
    tx.objectStore(STORE).put(value, key);
    tx.oncomplete = () => { db.close(); resolve(); };
    tx.onerror = () => { db.close(); reject(tx.error); };
  });
}

async function dbDelete(key) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, 'readwrite');
    tx.objectStore(STORE).delete(key);
    tx.oncomplete = () => { db.close(); resolve(); };
    tx.onerror = () => { db.close(); reject(tx.error); };
  });
}

export async function persistAuthToken(token) {
  if (!token) return;
  try { await dbSet(TOKEN_KEY, token); } catch {}
}

export async function clearAuthToken() {
  try { await dbDelete(TOKEN_KEY); } catch {}
}
